import { Divider, Drawer, Space, Button, Radio, Checkbox, Select, Slider } from "antd";
import React from "react";
import moment from "moment";
import ColourPicker from "../../../globals/styles/ColourPicker";
import FontPicker from "../../../globals/styles/FontPicker";
import { usePrefs } from "../../../utils/Prefs";
import { apiCall } from "../../../utils/Api";

export default function Nav(props) {

    const [prefs, setPrefs] = usePrefs();
    const { edit = false, close = () => { } } = props;

    // set componenet specific
    const setData = (_data) => {
        setPrefs({ ...prefs, "nav_bar": { ...prefs.nav_bar, "data": _data } })
    }

    // set componenet agnostic
    const setContent = (_key, _data) => {
        setPrefs({ ...prefs, "nav_bar": { ...prefs.nav_bar, [_key]: _data } })
    }

    // Component agnostic
    const {
        name = "",
        container = true,
        data = {},
        date_changed = 0
    } = prefs.nav_bar;

    // Component specific
    const {
        text_preset = 0,
        text_colour = 0,
        background_colour = 0,
        selected_text_colour = 0,
        selected_background_colour = 0,
        letter_spacing = 0,
        // selected_background_animation = false,
        // selected_background_animation_style = "left-animation",
        // selected_background_animation_duration = 0.5,
        selected_underline = false,
        selected_underline_colour = 0,
        selected_underline_thickness = 2,
        selected_animation = false,
        selected_animation_style = "left-animation",
        selected_animation_duration = 0.5,
        transform = "none",
        spacing = 20,
        font_size = 14,
        pinned = false,
    } = data;

    const save = () => {
        props.saveItem("nav_bar", prefs.nav_bar);
        close();
    }

    // Re-fetch old and update ui element
    const onCancel = () => {
        apiCall("site_content/getContent", {}, (_status, _result) => {
            if (_status) {
                if (_result) {
                    let _r = _result.find(item => item.component === "nav_bar")
                    if (_r) {
                        setPrefs({ ...prefs, "nav_bar": { ...prefs.nav_bar, "data": _r.data, "container": _r.container } })
                    }
                }
            }
        })
        close();
    }

    const drawForm = () => {
        return (
            <>
                <div style={{ "fontSize": "18px", "lineHeight": "18px" }}><strong>{name}</strong></div>
                {(date_changed && <em style={{ "fontSize": "12px" }}>Last updated {moment(date_changed * 1000).format("MMM Do, YYYY h:mm a")}</em>)}
                <div className="shim" /><div className="shim" />
                <div style={{ "display": "flex", "justifyContent": "stretch" }}>
                    <Button onClick={() => save()} block size="small" type="primary"><small>Save Changes</small></Button>
                    <div style={{ "width": "10px" }}></div>
                    <Space>
                        <Button onClick={() => onCancel()} size="small" type="default"><small>Cancel</small></Button>
                    </Space>
                </div>
                <div style={{ "margin": "0px -25px" }}><Divider style={{ "margin": "15px 0px" }} /></div>
                {/* CONTAINER */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">LAYOUT</Divider>
                <div className="float-flex">
                    <div></div>
                    <Space>
                        <Radio.Group value={container} onChange={(e) => setContent("container", e.target.value)} >
                            <Radio value={false}><small>100% of the screen width</small></Radio>
                            <Radio value={true}><small>Container width (max 1248px)</small></Radio>
                        </Radio.Group>
                    </Space>
                </div>
                <div className="shim" /><div className="shim" />

                {/* DISPLAY */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">DISPLAY</Divider>
                <div className="float-flex">
                    <div></div>
                    <Space>
                        <Radio.Group value={pinned} onChange={(e) => setData({ ...data, "pinned": e.target.value })} >
                            <Radio value={true}><small>Always show</small></Radio>
                            <Radio value={false}><small>Hide when scrolling down</small></Radio>
                        </Radio.Group>
                    </Space>
                </div>
                <div className="shim" /><div className="shim" />


                {/* TEXT PRESET */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">FONT</Divider>
                {/* <PresetPicker value={text_preset} onChange={(e) => setData({ ...data, "text_preset": e })} /> */}
                <FontPicker value={text_preset} onChange={(e) => setData({ ...data, "text_preset": e })} />
                <div className="shim" /> <div className="shim" />

                {/* STACK */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">TEXT TRANSFORM</Divider>
                <Select value={transform} onChange={(e) => setData({ ...data, "transform": e })} style={{ "borderBottom": "1px solid #eee", "width": "100%" }} bordered={true}>
                    <Select.Option key={"none"} value={"none"}><small>None</small></Select.Option>
                    <Select.Option key={"capitalize"} value={"capitalize"}><small>Capitalize</small></Select.Option>
                    <Select.Option key={"lowercase"} value={"lowercase"}><small>Lowercase</small></Select.Option>
                    <Select.Option key={"uppercase"} value={"uppercase"}><small>Uppercase</small></Select.Option>
                </Select>
                <div className="shim" /> <div className="shim" />

                {/* SPACING */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">GAP</Divider>
                <Slider defaultValue={spacing} onChange={(e) => setData({ ...data, "spacing": e })} min={10} max={100} />

                {/* FONT SIZE */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">FONT SIZE</Divider>
                <Slider defaultValue={font_size} onChange={(e) => setData({ ...data, "font_size": e })} min={10} max={24} />

                {/* LETTER SPACING */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">LETTER SPACING</Divider>
                <Slider defaultValue={letter_spacing} onChange={(e) => setData({ ...data, "letter_spacing": e })} min={0} max={5} />


                {/* TEXT COLOUR */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">TEXT COLOUR</Divider>
                <ColourPicker allow_none allow_gradient value={text_colour} onChange={(e) => setData({ ...data, "text_colour": e })} />
                <div className="shim" /> <div className="shim" />
                {/* BACKGROUND COLOUR */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BACKGROUND COLOUR</Divider>
                <ColourPicker allow_none allow_gradient value={background_colour} onChange={(e) => setData({ ...data, "background_colour": e })} />
                <div className="shim" /> <div className="shim" />
                {/* SELECTED TEXT COLOUR */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">SELECTED TEXT COLOUR</Divider>
                <ColourPicker allow_none allow_gradient value={selected_text_colour} onChange={(e) => setData({ ...data, "selected_text_colour": e })} />
                <div className="shim" /> <div className="shim" />
                {/* SELECTED BACKGROUND COLOUR */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">SELECTED BACKGROUND COLOUR</Divider>
                <ColourPicker allow_none allow_gradient value={selected_background_colour} onChange={(e) => setData({ ...data, "selected_background_colour": e })} />
                <div className="shim" /> <div className="shim" />

                {/* ACTIVATE BACKGROUND ANIMATION */}
                {/* <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BACKGROUND ANIMATION</Divider>
                <Checkbox checked={selected_background_animation} onChange={(e) => setData({ ...data, "selected_background_animation": e.target.checked })} ><small>Activate Background Animation?</small></Checkbox>
                <div className="shim" /> <div className="shim" /> */}

                {/* BACKGROUND ANIMATION STYLE */}
                {/* <Divider orientationMargin={0} orientation="left" plain className="simple-divider">ANIMATION STYLE</Divider>
                <Select disabled={!selected_background_animation} value={selected_background_animation_style} onChange={(e) => setData({ ...data, "selected_background_animation_style": e })} size="small" style={{ "width": "100%" }} >
                    <Select.Option key="left-animation" value="left-animation"><small>Left</small></Select.Option>
                    <Select.Option key="right-animation" value="right-animation"><small>Right</small></Select.Option>
                    <Select.Option key="center-animation" value="center-animation"><small>Center</small></Select.Option>
                </Select>
                <div className="shim" /> <div className="shim" /> */}

                {/* BACKGROUND ANIMATION DURATION */}
                {/* <Divider orientationMargin={0} orientation="left" plain className="simple-divider">ANIMATION DURATION</Divider>
                <Slider disabled={!selected_background_animation} defaultValue={selected_background_animation_duration} onChange={(e) => setData({ ...data, "selected_background_animation_duration": e })} min={0.3} max={1} step={0.1} />
                <div className="shim" /> <div className="shim" /> */}

                { /* ACTIVATE UNDERLINE */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">UNDERLINE</Divider>
                <Checkbox checked={selected_underline} onChange={(e) => setData({ ...data, "selected_underline": e.target.checked })} ><small>Underline Selected?</small></Checkbox>
                <div className="shim" /> <div className="shim" />




                {/* UNDERLINE COLOUR */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">SELECTED UNDERLINE COLOUR</Divider>
                <ColourPicker disabled={!selected_underline} allow_none allow_gradient value={selected_underline_colour} onChange={(e) => setData({ ...data, "selected_underline_colour": e })} />
                <div className="shim" /> <div className="shim" />

                {/* UNDERLINE THICKNESS */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">UNDERLINE THICKNESS</Divider>
                <Slider disabled={!selected_underline} defaultValue={selected_underline_thickness} onChange={(e) => setData({ ...data, "selected_underline_thickness": e })} min={1} max={3} />

                { /* ACTIVATE UNDERLINE */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">UNDERLINE ANIMATION</Divider>
                <Checkbox disabled={!selected_underline} checked={selected_animation} onChange={(e) => setData({ ...data, "selected_animation": e.target.checked })} ><small>Activate Underline Animation?</small></Checkbox>
                <div className="shim" /> <div className="shim" />

                {/* UNDERLINE ANIMATION */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">ANIMATION STYLE</Divider>
                <Select disabled={!selected_animation} value={selected_animation_style} onChange={(e) => setData({ ...data, "selected_animation_style": e })} size="small" style={{ "width": "100%" }} >
                    <Select.Option key="left-animation" value="left-animation"><small>Left</small></Select.Option>
                    <Select.Option key="right-animation" value="right-animation"><small>Right</small></Select.Option>
                    <Select.Option key="center-animation" value="center-animation"><small>Center</small></Select.Option>
                </Select>
                <div className="shim" /> <div className="shim" />

                {/* UNDERLINE THICKNESS */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">ANIMATION DURATION</Divider>
                <Slider disabled={!selected_animation} defaultValue={selected_animation_duration} onChange={(e) => setData({ ...data, "selected_animation_duration": e })} min={0.1} max={1} step={0.1} />

            </>
        )
    }
    return (
        <>
            <Drawer bodyStyle={{ "backgroundColor": "#f5f5f5", "overflowX": "hidden" }} closable={false} width={300} onClose={() => onCancel(true)} open={edit}>
                {drawForm()}
            </Drawer>
        </>
    )
}